<template>
  <div
    id="topup-mobile"
    class="carry-out-details mobile-card-select d-sm-none profile-account d-none"
  >
    <div class="checkout-card px-0 pb-0">
      <div class="back-cart">
        <a href="#" class="topup-back">
          <svg width="24" height="24" fill="none">
            <use xlink:href="#left_arrow" />
          </svg>
        </a>
      </div>
      <h4>
        {{ _T('Top up') + ' ' }}
        {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order') }}
      </h4>
    </div>
    <div class="select-card">
      <div class="amount-data">
        <div class="form-group">
          <label>
            {{ _T('Enter Amount') }}
          </label>
          <input type="text" class="form-control" value="AED50" />
          <img src="assets/svg/global/close-b.svg" alt="" />
        </div>
        <ul>
          <li class="active">
            <div class="amount-icon amount-warning">
              <img src="assets/svg/wallet/2.svg" alt="" />
            </div>
            <div class="bottom-true">
              <img src="assets/svg/wallet/true.svg" alt="" />
            </div>
            <h6>AED 50</h6>
          </li>
          <li>
            <div class="amount-icon amount-teritary">
              <img src="assets/svg/wallet/3.svg" alt="" />
            </div>
            <div class="bottom-true">
              <img src="assets/svg/wallet/true.svg" alt="" />
            </div>
            <h6>AED 100</h6>
          </li>
          <li>
            <div class="amount-icon amount-primary">
              <img src="assets/svg/wallet/4.svg" alt="" />
            </div>
            <div class="bottom-true">
              <img src="assets/svg/wallet/true.svg" alt="" />
            </div>
            <h6>AED 150</h6>
          </li>
          <li>
            <div class="amount-icon amount-light">
              <img src="assets/svg/wallet/5.svg" alt="" />
            </div>
            <div class="bottom-true">
              <img src="assets/svg/wallet/true.svg" alt="" />
            </div>
            <h6>AED 200</h6>
          </li>
        </ul>
      </div>
    </div>
    <div class="select-card">
      <div class="change-amount-card add-new-card">
        <h6>
          {{ _T('Payment Method') }}
          <a href="#" data-toggle="modal" data-target="#payment-card">{{
            _T('Change Card')
          }}</a>
        </h6>
        <ul>
          <li>
            <label>
              <span>
                <div class="media">
                  <img src="assets/images/checkout/round-card.png" alt="" />
                  <div class="media-body">
                    <h6>XXXX-XXXX-XXXX-9862</h6>
                    <span>09/10</span>
                  </div>
                </div>
              </span>
            </label>
          </li>
        </ul>
      </div>
    </div>
    <div class="amount-bottom">
      <h6>
        <img src="assets/svg/wallet/proceed.svg" alt="" />
        {{ _T('All your transactions are secure and fast') }}
      </h6>
      <div class="proceed-btn">
        <button
          data-toggle="modal"
          data-target="#success-topup"
          class="btn btn-block btn-solid"
        >
          {{ _T('Proceed') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand', '_T_DB', 'currentBrand']),
  },
}
</script>
